import axios from 'axios'
import Utils from '@/common/Utils'

const headers = { 'Content-Type': 'application/json' }
const url = `${process.env.VUE_APP_UTILS_API}/api`
const localUrl = `${process.env.VUE_APP_BASEPATH}/api`

export default class ComplaintService {
    static async getReuneStatus () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/status`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneReceptionMedium () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/medios-recepcion`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneAttentionLevels () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/niveles-atencion`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneOperations (recordOption = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/operacion/${recordOption}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneProducts (operationType = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/productos/${operationType}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneSubproducts (productType = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/subproductos/${productType}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneReasons (subproductType = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/motivos/${subproductType}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getReuneResolutions () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/reune/resoluciones`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoStatus () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/redeco/status`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoReceptionMedium () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/medios-recepcion`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoAttentionLevels () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/niveles-atencion`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoOperations () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/redeco/operacion`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoProducts () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/productos`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoSubproducts (productType = '') {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/redeco/subproductos/${productType}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoPenalties () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/redeco/penalizaciones`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoResolutions () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/redeco/resoluciones`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoReasons (product) {
        try {
            if (!product) throw new Error('No se ha proporcionado el producto')
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/causas`, { headers, params: { product } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getCondusefStatesCatalog () {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/api/states`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getCondusefPostalCodesCatalog (stateId) {
        try {
            if (!stateId) throw new Error('No se ha proporcionado la entidad federativa')
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/codigos-postales`, { headers, params: { stateId } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getCondusefMunicipalitiesCatalog (stateId, postalCode) {
        try {
            if (!stateId) throw new Error('No se ha proporcionado la entidad federativa')
            if (!postalCode) throw new Error('No se ha proporcionado el código postal')
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/municipios`, { headers, params: { stateId, postalCode } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getCondusefColoniesCatalog (postalCode) {
        try {
            if (!postalCode) throw new Error('No se ha proporcionado el código postal')
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/colonias`, { headers, params: { postalCode } })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getRedecoEntitiesCatalog (params = {}) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${localUrl}/redeco/entidades`, { headers, params })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
